import React, { useState } from 'react'
import "./RelatedProduct.css"

const RelatedProduct = ({product}) => {
  const { name, category, price, images, stock } = product;
    const [loading, setLoading] = useState(false); 
  const totalStock = stock.reduce(
    (acc, item) => acc + parseInt(item.quantity, 10),
    0
  );

  return (
    <>

    <div className="product-card" key={product._id}>
    <div className="product-image">
      <img
        src={`https://riymay.com/assets/${product.images[0]?.url}`}
        alt={product.images[0]?.altText || product.name}
      />
    </div>
    <div className="product-details">
      <p className="product-name">
        {product.name.length > 25
          ? `${product.name.substring(0, 25)}...`
          : product.name}
      </p>
      <div className="product-overlay">
        <button className="quick-shop-btn">Quick Shop</button>
        <div className="product-info">
          <div className="product-price">&#8377;{product.price}</div>
          <div className="sizes-product">
            {product.stock.map((stockItem) => (
              <button
                key={stockItem._id}
                className="size-button-product"
                disabled={stockItem.quantity <= 0}
              >
                {stockItem.size}
              </button>
            ))}
          </div>
        </div>
      </div>
    </div>
  </div>
  </>
  )
}

export default RelatedProduct
